import { EventEmitter } from '@angular/core';
import { AchooTextFieldComponent } from '../achoo-text-field/achoo-text-field.component';
import { StringUtils } from '../../utils/string.utils';
import { CampaignService } from '../../services/campaign/campaign.service';
import { MentionService } from '../../services/mention/mention.service';
import { ModalService } from '../../services/modal/modal.service';
import { AchooPopupComponent } from '../achoo-popup/achoo-popup.component';
import { ReferenceDataService } from '../../services/reference-data/reference-data.service';
import { ValidationHandlerService } from '../validation-handler.service';
import { TranslateService } from '@ngx-translate/core';
import { ActionSource } from '../../services/event-tracker/event-tracker.service';
import { ActivePage } from '../../../models/event-tracker';
import { UserService } from '../../services/user.service';
var AchooKeyworkInputFieldComponent = /** @class */ (function () {
    function AchooKeyworkInputFieldComponent(campaignService, mentionService, referenceDataService, validateErrorHandler, userService, modalService, translate) {
        this.campaignService = campaignService;
        this.mentionService = mentionService;
        this.referenceDataService = referenceDataService;
        this.validateErrorHandler = validateErrorHandler;
        this.userService = userService;
        this.modalService = modalService;
        this.translate = translate;
        this.readOnly = false;
        this.mentions = [];
        this.checkMentionExisting = true;
        this.isEditProjectFragment = false;
        this.beforeProgressingMention = new EventEmitter();
        this.afterProgressingMention = new EventEmitter();
        this.currentInputMention = '';
        this.currentDeleteMentionIndex = -1;
        this.errorMentions = [];
    }
    AchooKeyworkInputFieldComponent.prototype.ngOnInit = function () {
        if (!this.mentions) {
            this.mentions = [];
        }
        // load list supported countries
        if (this.enableCountry === true) {
            var referenceData = this.referenceDataService.referenceData;
            this.countryList = referenceData.countries.map(function (country) { return ({
                id: country.id,
                name: country.name
            }); });
        }
    };
    Object.defineProperty(AchooKeyworkInputFieldComponent.prototype, "mentionKeywords", {
        get: function () {
            return this.mentions ? this.mentions.map(function (x) { return x.keyword; }) : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AchooKeyworkInputFieldComponent.prototype, "processingMentionKeywords", {
        get: function () {
            return this.mentions ? this.mentions.filter(function (m) { return m.id === -1; }).map(function (x) { return x.keyword; }) : [];
        },
        enumerable: true,
        configurable: true
    });
    AchooKeyworkInputFieldComponent.prototype.mentionInputKeyDown = function (evt) {
        // User input something - not hit ENTER
        if (!evt || evt.keyCode !== 13) {
            return;
        }
        // User hit ENTER
        if (this.currentInputMention && StringUtils.trim(this.currentInputMention) !== '') {
            var mention = this.campaignService.parseMentions(this.currentInputMention);
            mention.language.push(0); // Todo: currently just use global language as temporaty
            if (this.isExistingMention(mention.keyword)) {
                // clear current input
                this.currentInputMention = '';
                // do nothing
                return;
            }
            // Update UI immediately.
            // Replace if add succeed
            // Remove if error catched
            if (!this.checkMentionExisting) {
                this.mentions.push({
                    id: -1,
                    keyword: mention.keyword
                });
                this.currentInputMention = '';
            }
            if (!this.activePage) {
                this.activePage = new ActivePage();
            }
            var activePage = {
                type: this.activePage.type,
                name: this.activePage.name,
                id: this.activePage.id
            };
            var actionSource = this.actionSource;
            this.mentionService.processNewMention(mention, this.beforeProcessingNewMention.bind(this), this.afterProcessingNewMention.bind(this), activePage, actionSource);
        }
    };
    AchooKeyworkInputFieldComponent.prototype.beforeProcessingNewMention = function (mention) {
        this.beforeProgressingMention.emit(mention);
    };
    AchooKeyworkInputFieldComponent.prototype.afterProcessingNewMention = function (data) {
        var _this = this;
        // if mention is not existed
        if (!data.alreadyExisted) {
            // has error during processing
            if (data.hasError) {
                // remove the processing mention
                var processingMention = this.mentions.find(function (men) { return men.keyword === data.errorMention.keyword; });
                // mark error mention with id = -2
                processingMention.id = -2;
                this.errorMentions.push(processingMention.keyword);
                this.modalService.open(this.errorWhenAddingNewMention, undefined, true);
            }
            else {
                setTimeout(function () {
                    _this.mentionInput.setFocus();
                }, 0);
                var selectdIndex = this.mentions.findIndex(function (m) { return m.keyword === data.newMention.keyword; });
                this.mentions.splice(selectdIndex, 1, data.newMention); // Replace
            }
        }
        else {
            // if mention is existed
            if (this.checkMentionExisting) {
                // if existing and need validate. show error message
                this.validateErrorHandler.updateErrors([{
                        name: this.name,
                        message: this.translate.instant('campaigns.mention_already_existed')
                    }]);
                this.validateErrorHandler.shouldDisplayErrors(true);
            }
            else {
                var selectedMention = this.mentions.find(function (men) { return StringUtils.trim(data.newMention.keyword.toLowerCase()) === StringUtils.trim(men.keyword.toLowerCase()); });
                if (selectedMention) {
                    selectedMention.id = data.newMention.id;
                }
            }
        }
        // after processing all mentions
        this.validateListMentionAfterProcessing(data.newMention);
    };
    /**
     * when all mention is valid and no mention is processing.
     * Trigger callback afterProcessing
     * @param processionMention
     */
    AchooKeyworkInputFieldComponent.prototype.validateListMentionAfterProcessing = function (processionMention) {
        // after processing all mentions
        var inProgressMentions = this.mentions.filter(function (m) { return m.id === -1; });
        if (inProgressMentions.length === 0 && this.errorMentions.length === 0) {
            this.afterProgressingMention.emit(processionMention);
        }
    };
    AchooKeyworkInputFieldComponent.prototype.isExistingMention = function (keyword) {
        if (!this.mentions) {
            return false;
        }
        return this.mentions.findIndex(function (mention) { return mention.keyword.toLowerCase() === keyword.toLowerCase(); }) >= 0;
    };
    AchooKeyworkInputFieldComponent.prototype.closeConfirmRemoveMentionMessage = function () {
        this.modalService.close();
    };
    AchooKeyworkInputFieldComponent.prototype.confirmationBeforeDeleteMention = function (index) {
        var currentMention = this.mentions[index];
        if (!currentMention) {
            return;
        }
        if (!this.isEditProjectFragment) {
            this.modalService.openInCenter(this.confirmRemoveMentionDialog);
        }
        this.currentDeleteMention = currentMention;
        this.currentDeleteMentionIndex = index;
        if (this.isEditProjectFragment) {
            this.onDeleteMention();
        }
    };
    AchooKeyworkInputFieldComponent.prototype.onDeleteMention = function () {
        if (!this.currentDeleteMention) {
            this.modalService.close();
            return;
        }
        var deleteItem = this.mentions[this.currentDeleteMentionIndex];
        // remove deleted item in error mention list
        this.errorMentions = this.errorMentions.filter(function (em) { return em !== deleteItem.keyword; });
        // remove item in mention list
        this.mentions.splice(this.currentDeleteMentionIndex, 1);
        // validate list mention
        this.validateListMentionAfterProcessing(deleteItem);
        // close modal
        this.modalService.close();
        this.currentDeleteMention = null;
        this.currentDeleteMentionIndex = -1;
    };
    return AchooKeyworkInputFieldComponent;
}());
export { AchooKeyworkInputFieldComponent };



// WEBPACK FOOTER //
// ./src/app/core/achoo-keywork-input-field/achoo-keywork-input-field.component.ts.pre-build-optimizer.js